import React from 'react'

import {
  classnames,
  Icon,
  ArrowRight,
  Radio,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string, func, oneOf, arrayOf } from 'prop-types'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

import roundHumanCount from 'Utils/roundHumanCount'
import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const BAND_PREMIUM = 'premium'

function SubscriptionOption({
  selected,
  onSelect: handleSelect,
  planName,
  band = 'essentials',
  bullets = EMPTY_ARRAY,
  downloadsPerMonth,
  catalogValue,
  pricePerModel,
  perModelLabel,
  fromLabel,
}) {
  const hasBackendBullets = Array.isArray(bullets) && bullets.length > 0
  const showLearnMore = band !== BAND_PREMIUM

  // stopPropagation keeps the surrounding option from being selected by this link.
  const handleLearnMoreClick = (event) => {
    event.stopPropagation()
    setSubscriptionEntry(SubscriptionEntryPoints.LANDING_LEARN_MORE)
  }
  const optionClass = classnames(
    'subscription-purchase__option',
    'subscription-purchase__option--subscription',
    selected && 'subscription-purchase__option--selected'
  )

  return (
    <div
      className={optionClass}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleSelect()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="subscription-purchase__option-radio">
        <Radio
          name="purchaseOption"
          isChecked={selected}
          onChange={handleSelect}
          className="subscription-purchase__radio"
        />
      </div>

      <div className="subscription-purchase__option-content">
        <div className="subscription-purchase__option-header">
          <span className="subscription-purchase__option-title">{planName}</span>
          <div className="subscription-purchase__option-price">
            <div className="subscription-purchase__option-price-row">
              <span className="cgt-body-base subscription-purchase__from-prefix">
                {fromLabel}
              </span>
              <span className="subscription-purchase__current-price">{pricePerModel}</span>
            </div>
            <span className="cgt-caption-semibold subscription-purchase__per-model-label">
              {`/${perModelLabel}`}
            </span>
          </div>
        </div>
        <ul className="subscription-purchase__benefits-list">
          {hasBackendBullets ? (
            bullets.map((text) => (
              <li key={text} className="subscription-purchase__benefits-item">{text}</li>
            ))
          ) : (
            <>
              <li className="subscription-purchase__benefits-item">Designed to meet your everyday needs</li>
              <li className="subscription-purchase__benefits-item">
                Download up to
                {' '}
                <strong className="subscription-purchase__benefits-highlight">
                  {downloadsPerMonth} models
                </strong>
                {' '}
                per month
              </li>
              <li className="subscription-purchase__benefits-item">
                Access a library of
                {' '}
                <strong className="subscription-purchase__benefits-highlight">{roundHumanCount(catalogValue)}</strong>
                {' '}
                premium models
              </li>
            </>
          )}
        </ul>
        {showLearnMore && (
          <a
            href="/subscription"
            className="subscription-purchase__learn-more"
            data-subscription-entry={SubscriptionEntryPoints.LANDING_LEARN_MORE}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLearnMoreClick}
          >
            Learn more
            <Icon svgComponent={ArrowRight} size="small" />
          </a>
        )}
      </div>
    </div>
  )
}

SubscriptionOption.propTypes = {
  selected: bool.isRequired,
  onSelect: func.isRequired,
  planName: string.isRequired,
  band: oneOf(['essentials', 'premium']),
  bullets: arrayOf(string),
  downloadsPerMonth: number.isRequired,
  catalogValue: string.isRequired,
  pricePerModel: string.isRequired,
  perModelLabel: string.isRequired,
  fromLabel: string.isRequired,
}

export default SubscriptionOption
